module.exports = __webpack_public_path__ + "img/1568626792.ce7b2a52.jpg";